import { gql } from "@apollo/client";


// To Create the Teacher
export const CREATE_TEACHERS = gql`
mutation CreateTeachers($input: CreateTeachersInput!) {
  createTeachers(input: $input) {
    message
  }
}`